import axios from 'axios'
import {getAuth} from '../modules/auth'
import {UposlenikModel} from '../models/UposlenikModel'

const API_URL = process.env.REACT_APP_API_URL
const API = `${API_URL}/paneli/prometRolnePaneli`
const API_TRAKE = `${API_URL}/paneli/prometTrakePaneli`
const auth: UposlenikModel = getAuth()!
const headers = {Accept: 'application/json', Authorization: auth?.access_token ?? ''}

export async function prometRolnePaneli(Data: any) {
  try {
    const response = await axios.post(API, Data, {headers: headers})
    if (response.data.error === 0) {
      return response.data
    } else {
      // Handle any other type of response structure or errors returned from the server here
      throw new Error(response.data.message || 'Failed to fetch.')
    }
  } catch (error) {
    console.error('Error fetching data:', error)
    throw error // Re-throw the error so it can be handled by the caller if necessary
  }
}

export async function prometTrakePaneli(Data: any) {
  try {
    const response = await axios.post(API_TRAKE, Data, {headers: headers})
    if (response.data.error === 0) {
      return response.data
    } else {
      // Handle any other type of response structure or errors returned from the server here
      throw new Error(response.data.message || 'Failed to fetch.')
    }
  } catch (error) {
    console.error('Error fetching data:', error)
    throw error // Re-throw the error so it can be handled by the caller if necessary
  }
}

export async function getPanelNalogDetalji(params) {
  return await axios.get(`${API_URL}/paneli/getPanelNalogDetalji`, {
    headers: headers,
    params: params,
  })
}
